<script>
import Edit from '../../SaleAccount/Modal/Edit.vue'
export default {
  extends: Edit
}
</script>
